import { Tab } from '../../types/tab';
import { waitForSeconds } from '../../helpers/asyncHelper';
import { tabDatabase } from './tabDatabse';
import { ITabService } from '../tabService';

export const TabServiceMock: ITabService = {

    async getTab(key: string): Promise<Tab|null> {
        await waitForSeconds(0.5);

        if (tabDatabase[key] === undefined)
            return null;

        return tabDatabase[key];
    },

};